import api from './api';

export interface ContractTemplate {
  id: number;
  name: string;
  category: 'subcontracting' | 'employment' | 'regulations' | 'protocols';
  google_doc_url: string;
  description?: string;
  version?: string;
  status?: string;
  created_by_user_id?: string;
  created_at: string;
  updated_at: string;
  creator?: {
    user_id: string;
    email: string;
    display_name?: string;
    first_name?: string;
    last_name?: string;
    avatar_url?: string;
  };
}

export interface CreateTemplateData {
  name: string;
  category: 'subcontracting' | 'employment' | 'regulations' | 'protocols';
  google_doc_url: string;
  description?: string;
  version?: string;
  status?: string;
}

export interface UpdateTemplateData {
  name?: string;
  category?: 'subcontracting' | 'employment' | 'regulations' | 'protocols';
  google_doc_url?: string;
  description?: string;
  version?: string;
  status?: string;
}

class ContractTemplateService {
  private baseURL = '/contract-templates';

  async getAllTemplates(category?: string, search?: string): Promise<ContractTemplate[]> {
    try {
      const params: any = {};
      if (category) params.category = category;
      if (search) params.search = search;
      
      const response = await api.get(this.baseURL, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  }

  async getTemplateById(id: number): Promise<ContractTemplate> {
    try {
      const response = await api.get(`${this.baseURL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching template:', error);
      throw error;
    }
  }

  async createTemplate(data: CreateTemplateData): Promise<ContractTemplate> {
    try {
      const response = await api.post(this.baseURL, data);
      return response.data;
    } catch (error) {
      console.error('Error creating template:', error);
      throw error;
    }
  }

  async updateTemplate(id: number, data: UpdateTemplateData): Promise<ContractTemplate> {
    try {
      const response = await api.put(`${this.baseURL}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating template:', error);
      throw error;
    }
  }

  async deleteTemplate(id: number): Promise<void> {
    try {
      await api.delete(`${this.baseURL}/${id}`);
    } catch (error) {
      console.error('Error deleting template:', error);
      throw error;
    }
  }

  async createDocument(name: string, category: 'subcontracting' | 'employment' | 'regulations' | 'protocols'): Promise<{ documentId: string; webViewLink: string }> {
    try {
      const response = await api.post(`${this.baseURL}/create-document`, { name, category });
      return response.data;
    } catch (error) {
      console.error('Error creating document:', error);
      throw error;
    }
  }
}

export default new ContractTemplateService();
